import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from 'components/Flex';
import Icon from 'components/Icon';
function CalendarStatus(_ref) {
  var _ref$status = _ref.status,
    status = _ref$status === void 0 ? 'success' : _ref$status,
    translationKey = _ref.translationKey;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Flex, {
    gap: "xs"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "calendar",
    color: status === 'fail' ? 'alert-fail' : 'alert-success'
  }), t(translationKey));
}
export default CalendarStatus;